import { EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { COMMA, ENTER, P } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { FlightService } from 'src/app/services/flight.service';
import { DataService } from 'src/app/services/data.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SettingsService } from '../../services/settings.service';
import { CarrierCodeService } from '../../services/carrier-code.service';
import { ColorsService } from 'src/app/services/colors.service';
import * as XLSX from "xlsx";
import * as ExcelJS from 'exceljs';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';

import { DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialogConfig } from '@angular/material/dialog';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { Pipe, PipeTransform } from '@angular/core';
import { AirConfigService } from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatTabGroup } from '@angular/material/tabs';
import jwt_decode from 'jwt-decode';
import { TripService } from 'src/app/services/trip.service'

@Component({
  selector: 'app-intl-flight-list',
  templateUrl: './intl-flight-list.component.html',
  styleUrls: ['./intl-flight-list.component.css']
})
export class IntlFlightListComponent implements OnInit {

  showSidebar: boolean = false


  airlines: any
  stop: any
  filterTime: any
  CancellationTab: boolean = false
  minData = new Date()
  fairRbookingDetail: any
  carrierCode: Map<String,any> = new Map<String,any>()
  fairbookingDetail: any
  uniqueNumbers: any
  uniqueFlightName: any
  sharePopup: boolean = false
  messageResult: any
  currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 0;
  selectedItem: string = 'Economy';
  selectedPerson: string = 'Adult'
  adult: any;
  child: any;
  Infants: any;
  journeyType = "oneWay";
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesTo: number[] = [ENTER, COMMA];
  announcer = inject(LiveAnnouncer);
  fromAirportError: boolean = false
  toAirportError: boolean = false
  // fruitCtrl = new FormControl('');
  // filteredFruits!: Observable<string[]>;
  // fruits: any;
  // allFruits:any = [];
  whereTo: any = [];
  showOneWay: boolean = false
  showReturn: boolean = false
  showMulti: boolean = false
  ToCtrl = new FormControl('');
  wherecity: any;
  // @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  @ViewChild('airportToInput') ToInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pickers') datePicker!: ElementRef<HTMLInputElement>;
  dynamicTooltip: any = ""
  searchFg!: FormGroup
  dates: Date[] = [];
  selectedDate: Date | null = null;
  currentDate: Date = new Date();
  messageData: any;
  departureFlight: any
  returnFlight: any
  showPending: boolean = false
  returnflight: any
  flightDetail: any
  returnFlightDetail: any
  flightDetails: boolean = true
  flightDataList?: Map<String,any>
  userType: any
  viewData: boolean = false
  allEmailData: any = []
  SelectedEmailData: any = []
  SelectedInboundEmail: any = []
  SelectedInboundEmailData: any = []
  userUuid: any
  allInboundEmailData: any = []
  SelectedView: boolean = false
  domIn: any = {
    international: false,
    domestic: false
  }
  username: any
  color: any
  parentType: any
  pointerEvents:boolean=false
  constructor(private DialogService:DialogService,private UserService: UserService, private TripService: TripService, private UserprofileService: UserprofileService, private SettingsService: SettingsService, private toastMsgService: ToastmsgService, private fb: FormBuilder, private FlightService: FlightService, private route: ActivatedRoute
    , private router: Router, private data: DataService, private CarrierCodeService: CarrierCodeService, private AirConfigService: AirConfigService, private userInfoService: UserInfoService, private cdr: ChangeDetectorRef, private ColorsService: ColorsService) {
    this.ENABLE_TRIP_MGMT()
    let ite: string = userInfoService.getParentUser() || ''
    if (ite) {
      let token: any = jwt_decode(ite)
      if (token) {
        this.parentType = token?.type


      }
    }

    this.username = userInfoService.getUsername();
    this.ColorsService.colors("", "").then((color: any) => {
      this.color = color
    })
      .catch((error: any) => {
      });
    this.userType = this.userInfoService.getUserType()
    this.userType = this.userType.toUpperCase()

    this.userUuid = this.userInfoService.getUserUuid()

    this.getActiveTripList()
    // console.log(this.userUuid)
    this.AirConfigService
      .getGeneralConfig(this.userUuid)
      .subscribe({
        next: (res: any) => {
          if (res) {
            let data = res
            // console.log(data[0])
            this.domIn.international = data[0]?.internationalEnabled
            this.domIn.domestic = data[0]?.domesticEnabled
            // console.log( this.domIn)



          } else {

          }
        }, error: (err) => {

        }
      }
      )


    
    this.CarrierCodeService.carrierCode().forEach(({carrierCode:code,...rest}:any)=>{
      this.carrierCode.set(code,rest)
    })
    // this.imageData()
    this.getCorporateUsers()
    // this.getFlightList()
    this.route.queryParams.subscribe(params => {
      let data: any
      data = params

    });
    this.data.portMessage.subscribe((message: any) => this.messageData = message)

    this.data.deliverMsg(this.messageData)
    this.pointerEvents=this.messageData.pointerEvents


    // console.log('jhjh')
    if (this.messageData.journeyType) {
      // console.log('jhjh')

      this.journeyType = this.messageData.journeyType
    }

    if (this.messageData === "default message") {
   
    } else {
      this.getFlightList()
      this.searchFlight()
// this.test()
    }

    // this.dataFields()
    // this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
    //   debounceTime(300), // Adjust the debounce time as needed
    //   distinctUntilChanged(),
    //   startWith(null),
    //   map((airport: any | null) => (airport ? this._filter(airport) : this.allFruits.slice())),
    // );
    // this.filteredTo = this.ToCtrl.valueChanges.pipe(
    //   debounceTime(300), // Adjust the debounce time as needed
    //   distinctUntilChanged(),
    //   startWith(null),
    //   map((airports: any | null) => (airports ? this._filterTo(airports) : this.whereTo.slice())),
    // );

    //this.ToInput.nativeElement.value='DEL'
    // this.searchFg=this.fb.group({
    //       "fromAirport" :  ['',[Validators.required]],
    //       "toAirport" : ['',[Validators.required]],
    //       "requestedDate":[ this.messageData.airSearchRequestBaseDetails[0].requestedDate],
    //       "requestedClass":[''],
    //       "paxCount":[0],
    //       "adultCount":[0],
    //       "childCount":[0],
    //       "infantCount":[0],
    //       "returnDate":[this.messageData?.airSearchRequestBaseDetails[1]?.requestedDate],
    //       "menu":[this.journeyType]
    //     });
  }

  ngOnInit(): void {
    this.populateDates();
    this.selectedDate = this.currentDate;

  }
  step: number = 1;

  setStep(index: number): void {
    this.step = index;
  }
  selectDate(date: Date) {
    this.selectedDate = date;
  }

  populateDates() {
    this.dates = [];
    const weekStartDate = new Date(this.currentDate);
    weekStartDate.setDate(weekStartDate.getDate() - weekStartDate.getDay()); // Start of the current week
    for (let i = 0; i < 7; i++) {
      this.dates.push(new Date(weekStartDate));
      weekStartDate.setDate(weekStartDate.getDate() + 1); // Move to the next day
    }
  }

  navigateWeek(offset: number) {
    const newDate = new Date(this.currentDate);
    newDate.setDate(newDate.getDate() + offset * 7); // Move to the next or previous week
    this.currentDate = newDate;
    this.populateDates();
    this.selectedDate = this.currentDate;
  }
  generateJourneyKey(flightDetails: any) {
    return flightDetails
      .map((detail: any) => `${detail.flightNumber}-${detail.carrierName}`)
      .join("|");
  }
  groupAndMergeFlights(flights: any) {
    const journeyMap = new Map();

    flights.forEach((flight: any) => {
      const journeyKey = this.generateJourneyKey(flight.flightDetailsList);

      if (journeyMap.has(journeyKey)) {
        const existingJourney = journeyMap.get(journeyKey);
        flight.fare.forEach((fare: any) =>
          existingJourney.fare.push({ ...fare, source: flight.source })
        );
        existingJourney.originalFlights[flight.source] = flight;
      } else {
        journeyMap.set(journeyKey, {
          ...flight,
          flightDetails: flight.flightDetailsList,
          fare: flight.fare.map((fare: any) => ({
            ...fare,
            source: flight.source,
          })),
          originalFlights: { [flight.source]: flight },
        });
      }
    });

    return Array.from(journeyMap.values());
  }

  visibleflights:any=[]
  blankList:boolean=false
  searchFlight() {
    this.blankList=false

    if (this.userType === 'AGENT') {


      this.IncentiveBoolean()
    }
    this.enableCheck = false

    setTimeout(() => {
      this.showPending = false

    }, 20 * 60 * 1000);
    this.endIndex = 20;  // Start by showing the first 10 items
  this.increments = 20;
  this.visibleflights=[]
    this.filterTime = null
    this.popupData=null
    this.airlines = null
    this.stop = null
    this.fareType = null
    this.showPending = true
    let flightDetail: any = []
    this.flightDetail = []
    this.returnFlightDetail = []

    this.returnFlight = null
    this.departureFlight = null
    this.returnflight = null
    let request = JSON.parse(JSON.stringify(this.messageData))
    delete request.uuid;
    let subEmail: any = []
    if (request.travelType === 'AD') {
      this.subjectEmail = 'DomesticAir Results |'

      for (let item of request.airSearchRequestBaseDetails) {
        subEmail.push(item.fromAirport + '-' + item.toAirport + ' on ' + item.requestedDate.split('T')[0])

      }

    } else {
      this.subjectEmail = 'InternationalAir Results | '

      for (let item of request.airSearchRequestBaseDetails) {
        subEmail.push(item.fromAirport + '-' + item.toAirport + ' on ' + item.requestedDate.split('T')[0])

      }

    }
    this.subjectEmail += subEmail.join('|')
    this.FlightService.SearchFlight(request)
      .subscribe({
        next: (res) => {
          // console.log(res)
          let data: any
          // console.log(res)
          data = res.body
          this.showPending = false


          if (data&&data.length > 0 ) {



            // data.forEach((flight: any) => {
            //   flight.flights = this.groupAndMergeFlights(flight.flights);
            // })
           
            flightDetail = data
           
            if (flightDetail) {
              for(let fly of flightDetail){
              // for (let i = 0; i < fly.itineraries.length; i++) {
                fly.dropDown = false
                fly.selected = false
                fly.fare.forEach(function (item: any) { item.selected = '' })
                fly.fare.forEach((item: any, index: number) => {
                  item.number = index;
                });

              }
              this.onClickFare(flightDetail[0].fare[0], flightDetail[0].fare, flightDetail[0])

            }
            this.returnflight = flightDetail
            // this.flightDetail=this.groupAndMergeFlights(flightDetail[0].flights);

            const uniqueNumbers = new Set<number>();
            const uniqueFlightName = new Set<any>();
            const commonNumbers: number[] = [];
            const commonFlightName: any[] = [];
            let combinedFlightSet: any
             let combinedSet: any

            for (let i = 0; i < this.returnflight.length; i++) {
            

              this.returnflight[i].itineraries[0].flight.flightDetailsList.forEach((equip: any) => {

              
            //   }

            //   )

              if (uniqueFlightName.has(this.returnflight[i].itineraries[0].flight.flightDetailsList[0].carrierName)) {
                // If the number is already in the set, it's a common number
                commonFlightName.push(this.returnflight[i].itineraries[0].flight.flightDetailsList[0].carrierName);
              } else {
                // Otherwise, add it to the set
                uniqueFlightName.add(this.returnflight[i].itineraries[0].flight.flightDetailsList[0].carrierName);
              }
              // Iterate through the array

              if (uniqueNumbers.has(this.returnflight[i].itineraries[0].flight.hopCount)) {
                // If the number is already in the set, it's a common number
                commonNumbers.push(this.returnflight[i].itineraries[0].flight.hopCount);
              } else {
                // Otherwise, add it to the set
                uniqueNumbers.add(this.returnflight[i].itineraries[0].flight.hopCount);
              }

            })}
 combinedFlightSet = new Set([...uniqueFlightName]);
            this.uniqueFlightName = combinedFlightSet
             combinedSet = new Set([...uniqueNumbers]);


            this.uniqueNumbers = combinedSet
            // // const uniqueRNumbers = new Set<number>();
            // // const commonRNumbers: number[] = [];
            // // const uniqueRFlightName = new Set<any>();
            // // const commonRFlightName: any[] = [];
            // let combinedSet: any
            // let combinedFlightSet: any
            // // if (this.returnflight[1]) {
            // //   for (let i = 0; i < this.returnflight[1].flights.length; i++) {
            // //     this.returnflight[1].flights[i].flightDetailsList.forEach((equip: any) => {
                
            // //     }
            // //     )
            // //     if (uniqueRFlightName.has(this.returnflight[1].flights[i].flightDetailsList[0].carrierName)) {
            // //       // If the number is already in the set, it's a common number
            // //       commonRFlightName.push(this.returnflight[1].flights[i].flightDetailsList[0].carrierName);
            // //     } else {
            // //       // Otherwise, add it to the set
            // //       uniqueRFlightName.add(this.returnflight[1].flights[i].flightDetailsList[0].carrierName);
            // //     }

            // //     // Iterate through the array

            // //     if (uniqueRNumbers.has(this.returnflight[1].flights[i].hopCount)) {
            // //       // If the number is already in the set, it's a common number
            // //       commonRNumbers.push(this.returnflight[1].flights[i].hopCount);
            // //     } else {
            // //       // Otherwise, add it to the set
            // //       uniqueRNumbers.add(this.returnflight[1].flights[i].hopCount);
            // //     }


            // //   }
            // // }
            // // combinedSet = new Set([...uniqueNumbers, ...uniqueRNumbers]);
            // combinedSet = new Set([...uniqueNumbers]);


            // this.uniqueNumbers = combinedSet

            // combinedFlightSet = new Set([...uniqueFlightName]);
            // this.uniqueFlightName = combinedFlightSet
            // //   console.log(commonNumbers)
            // //console.log(this.uniqueNumbers)
            // this.ActiveDeparture = this.returnflight[0]?.flights[0]
            // this.ActiveReturn = this.returnflight[1]?.flights[0]
            // this.departureFlight = { ...this.returnflight[0]?.flights[0] }
            // this.departureFlight.fare = [{ ...this.returnflight[0]?.flights[0].fare[0] }]
            // if (this.returnflight[1]?.flights[0]) {
            //   this.returnFlight = { ...this.returnflight[1]?.flights[0] }
            //   this.returnFlight.fare = [{ ...this.returnflight[1]?.flights[0].fare[0] }]
            // }

            // for (let i = 0; i < flightDetail[0].flights.length; i++) {
            //   flightDetail[0].flights[i].dropDown = false
            //   flightDetail[0].flights[i].selected = false
            //   flightDetail[0].flights[i].fare.forEach(function (item: any) { item.selected = '' })
            //   flightDetail[0].flights[i].fare.forEach((item: any, index: number) => {
            //     item.number = index;
            //   });
            // }
            // flightDetail[0].flights[0].selected = true

            // flightDetail[0].flights[0].fare[0].selected = 'true'
            // this.onClickFare(flightDetail[0].flights[0].fare[0], flightDetail[0].flights[0].fare, flightDetail[0].flights[0])

            // if (flightDetail[1]) {
            //   for (let i = 0; i < flightDetail[1].flights.length; i++) {
            //     flightDetail[1].flights[i].dropDown = false
            //     flightDetail[1].flights[i].selected = false
            //     flightDetail[1].flights[i].fare.forEach(function (item: any) { item.selected = '' })
            //     flightDetail[1].flights[i].fare.forEach((item: any, index: number) => {
            //       item.number = index;
            //     });


            //   }
            //   this.returnFlightDetail = flightDetail[1].flights

            // }
            // this.flightDetail = flightDetail[0].flights
               this.flightDetail = flightDetail

            this.loadMoreFlights()

           
            this.calculateMinMaxPrices()
            this.fareTypeFilter()
            if(this.messageData.airSearchRequestBaseDetails[0]?.travelTime){
              this.filterTime=this.messageData.airSearchRequestBaseDetails[0]?.travelTime||null
              this.combineFilters()
                    }
                    this.countdown = 300;
                    clearInterval(this.interval);

                    this.startTimer();
          } else {
            this.getFlightList()
            this.showPending = false
            // this.router.navigate(["/app/flight"]);
            this.blankList=true
            // this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });

          }

        }, error: (err) => {

          this.getFlightList()
          this.showPending = false

          //this.router.navigate(["/app/flight"]);
          this.blankList=true

          // this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });

        }
      }
      )
  }

  getSelectedFareOriginalFlight(journeyData: any, selectedFare: any) {
    // const originalFlight = journeyData.originalFlights[selectedFare.source];
    const originalFlight = journeyData;

    if (originalFlight) {
      return {
        ...originalFlight,
        fare: [selectedFare]
      };
    }
    return null;
  }

  converter(item: any) {
    const totalMinutes = item;
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    item = `${hours}h ${remainingMinutes}m`
    return item
  }

  convertInTime(item: any) {

    const hours = Math.floor(item / 100);
    const minutes = item % 100;
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${ampm}`;



    item = formattedTime;
    return item
  }
  formatTimeComponent(component: number): string {
    return component < 10 ? `0${component}` : component.toString();
  }





  getFlightList() {

    this.FlightService
      .getFlightList()
      .subscribe({
        next: (res: any) => {
          if (res) {
            let data: Array<any>;
            data = res
            let mappedDataWithIataCode:Map<String,any>=new Map<String,any>();
            
             data.forEach(({iataCode,...rest})=>{
              mappedDataWithIataCode.set(iataCode,rest);
             });
            this.flightDataList=mappedDataWithIataCode;
           
           








          } else {
          }
        }, error: (err) => {


        }
      }
      )
  }
  openReturnWindow() {
    let flightDetail: any = {}
    let returnDetail: any = {}
    // flightDetail={...this.departureFlight}
    let selectLFight = this.getSelectedFareOriginalFlight(this.departureFlight, this.fairbookingDetail)
    flightDetail = selectLFight;

    // if(this.fairbookingDetail){

    //   flightDetail.fare=[this.fairbookingDetail]
    // }
    returnDetail = { ...this.returnFlight }

    if (this.fairRbookingDetail) {
      returnDetail.fare = [{ ...this.fairRbookingDetail }]
    }
    let travellerDetails = {
      child: this.messageData.childCount,
      adult: this.messageData.adultCount,
      infantCount: this.messageData.infantCount,
    }
    //  let url= "/app/book?flightBooking="+JSON.stringify(flightDetail)+"&returnDetail="+JSON.stringify(returnDetail)+"&travellerDetails="+JSON.stringify(travellerDetails);
    //  window.open(url);
    let orderData: any
    if (Object.keys(returnDetail).length === 0) {
      orderData = { flightBooking: [flightDetail], travellerDetails: travellerDetails }
      orderData.flightBooking[0].fromAirport = this.returnflight[0].fromAirport
      orderData.flightBooking[0].toAirport = this.returnflight[0].toAirport


    } else {

      orderData = { flightBooking: [flightDetail, returnDetail], travellerDetails: travellerDetails }

      orderData.flightBooking[0].fromAirport = this.returnflight[0].fromAirport
      orderData.flightBooking[0].toAirport = this.returnflight[0].toAirport
      orderData.flightBooking[1].fromAirport = this.returnflight[1].fromAirport

      orderData.flightBooking[1].toAirport = this.returnflight[1].toAirport
    }


    this.generateOrder(orderData);
  }
  openReturnPopup() {
    this.flightDetails = false

    // this.getFareRules()
    // this.getRFareRules()
    // this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)), JSON.parse(JSON.stringify(this.returnFlight)))


  }
  onClickRFare(fare: any, item: any, items: any) {
    this.step = 1

    //console.log(item)
    items.selected = true

    for (let flight of this.returnFlightDetail) {
      flight.selected = false
      for (let i = 0; i < flight.fare.length; i++) {
        flight.fare[i].selected = ''

      }
    }
    items.selected = true

    for (let i = 0; i < item.length; i++) {

      item[i].selected = ''

    }
    fare.selected = 'true'


    this.fairRbookingDetail = fare
    this.returnFlight.fare = [this.fairRbookingDetail]
    this.getRFareRules()
    // this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)), JSON.parse(JSON.stringify(this.returnFlight)))

  }
  onClickFare(fare: any, item: any, items: any) {


    this.step = 1
    // if (this.returnflight[0]) {
    //   for (let i = 0; i < this.returnflight[0].flights.length; i++) {
    //     // this.returnflight[0].flights[i].dropDown=false
    //     this.returnflight[0].flights[i].selected = false
    //   }
    // }
    // this.activeDeparture(items)
    // for (let flight of this.flightDetail) {
    //   flight.selected = false
    //   for (let i = 0; i < flight.fare.length; i++) {
    //     flight.fare[i].selected = ''

    //   }
    // }
    if (this.returnflight) {
      for(let fly of this.returnflight){
      // for (let i = 0; i < fly.itineraries.length; i++) {
        // fly.dropDown = false
        fly.selected = false
        fly.fare.forEach(function (item: any) { item.selected = '' })
        // fly.fare.forEach((item: any, index: number) => {
        //   item.number = index;
        // });


      }}
    // flightDetail.fare[0].selected = 'true'


    // flightDetail.selected = true


    // flightDetail.dropDown = true
    items.selected = true

    // for (let i = 0; i < item.length; i++) {

    //   item[i].selected = ''


    // }
    // console.log(item)

    fare.selected = 'true'

    this.fairbookingDetail = fare
    this.departureFlight = { ...items }
    // this.departureFlight.fare = [{ ...this.fairbookingDetail }]

    // console.log(this.departureFlight)
    let reqeust:any=[]
    let dataRequest:any=JSON.parse(JSON.stringify(this.departureFlight))
    

    dataRequest.itineraries.forEach((air:any)=>{

      let flightdata:any
      flightdata=JSON.parse(JSON.stringify(air))
      // console.log(flightdata)
      flightdata.flight.fare=flightdata.flight.fare.filter((fare:any)=>fare.fareTypeDisplay===this.fairbookingDetail.fareTypeDisplay)
      // console.log(flightdata)

      flightdata.flight.fromAirport=flightdata.fromAirport

    
      flightdata.flight.toAirport=flightdata.toAirport

      
      reqeust.push(flightdata.flight)

    })
    this.popupData= reqeust
         this.getFareRules()
    // // console.log(this.departureFlight)
    for(let dataItem of this.popupData){
    this.getrepriceData(JSON.parse(JSON.stringify(dataItem)))
        // this.getrepriceData(dataItem)

    }
  }
  popupData:any

  openWindow(item: any): void {
    this.step = 0
    let flightDetail: any = {}
    let returnDetail: any = {}
   let reqeust:any=[]
    let selectLFight = this.getSelectedFareOriginalFlight(JSON.parse(JSON.stringify(this.departureFlight)), this.fairbookingDetail)
    selectLFight.itineraries.forEach((air:any)=>{
      air.flight.fare=air.flight.fare.filter((fare:any)=>fare.fareTypeDisplay===selectLFight.fare[0].fareTypeDisplay)
      

        air.flight.fromAirport=air.flight.flightDetailsList[0].fromAirport

    
        air.flight.toAirport=air.flight.flightDetailsList[air.flight.flightDetailsList.length-1].toAirport

      
      reqeust.push(air.flight)

    })
    


    flightDetail = reqeust;
    
    let travellerDetails = {
      child: this.messageData.childCount,
      adult: this.messageData.adultCount,
      infantCount: this.messageData.infantCount,
    }

    
    let orderData: any

    if (Object.keys(returnDetail).length === 0) {
      orderData = { flightBooking: flightDetail, travellerDetails: travellerDetails }
      // orderData.flightBooking[0].fromAirport = this.returnflight[0].fromAirport
      // orderData.flightBooking[0].toAirport = this.returnflight[0].toAirport


    }
    //  else {

    //   orderData = { flightBooking: [flightDetail, returnDetail], travellerDetails: travellerDetails }

    //   orderData.flightBooking[0].fromAirport = this.returnflight[0].fromAirport
    //   orderData.flightBooking[0].toAirport = this.returnflight[0].toAirport
    //   orderData.flightBooking[1].fromAirport = this.returnflight[1].fromAirport

    //   orderData.flightBooking[1].toAirport = this.returnflight[1].toAirport
    // }


    // console.log(orderData);
    this.generateOrder(orderData);

    
  }
  tripResponse: any
  showSpiner: boolean = false
  getActiveTripList() {
    this.TripService
      .getActiveTrip(this.userUuid)
      .subscribe({
        next: (res: any) => {
          if (res) {
            const data = res
            this.tripResponse = {
              tripName: data?.tripName,
              tripUid: data?.tripUid
            }

          } else {

          }
        }, error: (err) => {

          console.error("Error in fetching result");
        }
      })
  }

  tripEnable: boolean = false
  ENABLE_TRIP_MGMT() {

    this.UserService.ENABLE_TRIP_MGMT()
      .subscribe({
        next: (res: any) => {
          if (res) {
            if (res.policyType === 'TRIP_MGMT') {
              if (res.rule === '1') {
                this.tripEnable = true
              }else 
              if(res.rule==='2'){
                this.tripEnable=true
                          } else {
                this.tripEnable = false

              }

            }

          } else {

          }

          if(this.messageData==="default message"){

            if(this.tripEnable){
              
              this.router.navigate(["/app/trip"]);
            
            }else{
                  this.router.navigate(["/app/flight"]);}}
        }, error: (err) => {
          if(this.messageData==="default message"){

            if(this.tripEnable){
              
              this.router.navigate(["/app/trip"]);
            
            }else{
                  this.router.navigate(["/app/flight"]);}}
          console.error("Error in fetching data");
        }
      }
      )

  }
  generateOrder(data: any) {
    if (this.userType === 'STAFF') {
      let url = "/app/book"
      window.open(url);
    }else if(this.countdown===0){
      this.DialogService.open({msg : "Search session has been expired  need to Re-Search",title : "Confirmation",buttonType : "ref"})
             
      this.DialogService.onResponse((response :  string) => {
       
        if(response=="Search") {
          this.searchFlight()
  
  
        }})
    }  else {
      this.showSpiner = true
      data.requestUuid = this.messageData.uuid

      let airSearchRequest = JSON.parse(JSON.stringify(this.messageData))
      delete airSearchRequest.uuid;

      data.airSearchRequest = airSearchRequest
      data.channel = 'WEB'
      data.isDomestic = this.domIn.domestic
      data.isInternational = this.domIn.international
      if (this.tripEnable === true) {
        data.tripUid = this.tripResponse?.tripUid
      }
      this.FlightService
        .generateOrder(data)
        .subscribe({
          next: (res: any) => {
            this.showSpiner = false


            if (res) {

              let item: any
              item = res
              //  console.log(item?.orderNumber)
              let url = "/app/book?id=" + this.SettingsService.transform(item?.orderNumber)
              window.open(url);

            } else {
            }
          }, error: (err) => {
            this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });

            this.showSpiner = false


          }
        }
        )
    }
  }
  dateFormate(date: any) {
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-US');
    date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    return date

  }

  cityFilter(item: any) {
    // console.log(item)
    if (item && this.flightDataList) {
      
      return this.flightDataList.get(item)?.city;


     

    } else {
      return item
    }
  }
  airPortFilter(item: any) {
    if (item && this.flightDataList) {
      return this.flightDataList.get(item)?.name;
      // item = this.flightDataList.filter((itm: { iataCode: any; }) => itm.iataCode === item)

      // item = item[0]?.name
      return item
    } else {
      return item
    }
  }
  fligthNameFilter(item: any) {

    if (item) {
      return this.carrierCode.get(item)?.flightName??item;
     
    } else { return item }
  }
  flightlogoFilter(item: any) {

    if (item) {
      // let flightName: any = []
      return this.carrierCode.get(item)?.logo??item;

    } else { return item }
  }
  ActiveDeparture: any
  ActiveReturn: any
  selectFlight(item: any) {
    item.selected = true
    if (item == this.ActiveDeparture) {

    } else {

      this.ActiveDeparture = item
      this.departureFlight = { ...item }
      this.departureFlight.fare = [{ ...item.fare[0] }]

    }
  }
  selectRFlight(item: any) {
    if (item == this.ActiveReturn) {


      //this.returnFlight.fare=this.returnFlight.fare[0]

    } else {
      this.ActiveReturn = item
      this.returnFlight = { ...item }
      this.returnFlight.fare = [{ ...item.fare[0] }]

    }
  }
  activeDeparture(item: any) {
    if (item == this.ActiveDeparture) {

      return item
    }
  }
  activeReturn(item: any) {
    if (item == this.ActiveReturn) {
      return item
    }
  }
  openPopup(item: any, fare: any) {

    let flight: any
    flight = { ...item }

    this.departureFlight = flight
    this.departureFlight.fare = [fare]
    this.flightDetails = false;
  }
  closePopup() {
    this.sharePopup = false
    this.flightDetails = true;
    this.json = []
    this.rJson = []
    this.allEmailData = []
    this.allInboundEmailData = []
  }




 



  Tooltip(item: string) {
    item = "hello"
  }

  increment() {
    if (this.currentNumber < 9) {
      this.currentNumber++;
      this.adult = this.currentNumber + ` ` + "Adult"

    }
  }
  cIncrement() {
    if (this.ccurrentNumber < 9) {
      this.ccurrentNumber++;
      this.child = this.ccurrentNumber + ` ` + "Child"
    }
  }
  iIncrement() {
    if (this.icurrentNumber < 9) {
      this.icurrentNumber++;
      this.Infants = this.icurrentNumber + ` ` + "Infants"
    }
  }

  decrement() {
    if (this.currentNumber > 1) {
      this.currentNumber--;
      this.adult = this.currentNumber + ` ` + "Adult"

    }
  }
  cDecrement() {
    if (this.ccurrentNumber > 0) {
      this.ccurrentNumber--;
      this.child = this.ccurrentNumber + ` ` + "Child"

    }
  }
  iDecrement() {
    if (this.icurrentNumber > 0) {
      this.icurrentNumber--;
      this.Infants = this.icurrentNumber + ` ` + "Infants"

    }
  }
  selectItem(item: string) {
    this.selectedItem = item;
  }
  selectPerson(item: string) {
    this.selectedPerson = item;
  }
  selectedDetail: boolean = false

  SelectDetail() {
    this.selectedDetail = !this.selectedDetail

  }

  onArrowClick(item: any) {
    item = true
    // console.log(item)
  }



  formatDate(val: Date) {
    let convertedValue: any = ""
    if (val) {
      let datepipe = new DatePipe("en");
      //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
      convertedValue = datepipe.transform(val, "yyyy-MM-dd");
    }
    return convertedValue;
  }

  onClickDropdown(flightDetail: any) {
    //console.log(flightDetail)
    if (this.returnflight[1]) {
      for (let i = 0; i < this.returnflight[1].flights.length; i++) {
        this.returnflight[1].flights[i].dropDown = false
        this.returnflight[1].flights[i].fare.forEach(function (item: any) { item.selected = '' })


      }
    }
    flightDetail.fare[0].selected = 'true'

    flightDetail.dropDown = true
    // console.log('Sorted flights:', this.returnflight[0].flights);


  }
  onClickDropup(flightDetail: any) {

    //  console.log(flightDetail)
    if (this.returnflight[1]) {
      for (let i = 0; i < this.returnflight[1].flights.length; i++) {
        this.returnflight[1].flights[i].dropDown = false


      }
    }

    //console.log(flightDetail)
    //  if(this.returnflight[1]){
    //    for(let i=0;i<this.returnflight[1].flights.length;i++){
    //      this.returnflight[1].flights[i].dropDown=false
    //      this.returnflight[1].flights[i].fare.forEach(function(item: any) {item.selected=''})


    //    }}


  }

  onClickDepartureDown(flightDetail: any) {

    //console.log(flightDetail)
   
    if (this.returnflight) {
      for(let fly of this.returnflight){
      // for (let i = 0; i < fly.itineraries.length; i++) {
        fly.dropDown = false
        fly.selected = false
        fly.fare.forEach(function (item: any) { item.selected = '' })
        fly.fare.forEach((item: any, index: number) => {
          item.number = index;
        });


      }}
    flightDetail.fare[0].selected = 'true'


    flightDetail.selected = true


    flightDetail.dropDown = true

  }
  onClickDepartureUp(flightDetail: any) {

    // if (this.returnflight[0]) {
    //   for (let i = 0; i < this.returnflight[0].flights.length; i++) {
    //     this.returnflight[0].flights[i].dropDown = false


    //   }
    // }
    if (this.returnflight) {
      for(let fly of this.returnflight){
      // for (let i = 0; i < fly.itineraries.length; i++) {
        fly.dropDown = false
        // fly.selected = false
        // fly.fare.forEach(function (item: any) { item.selected = '' })
        // fly.fare.forEach((item: any, index: number) => {
        //   item.number = index;
        // });


      
    }}
    



  }
  passengerTypeMapping(item: any) {
    let type: any = []

    if (item) {

      //  console.log(item)
      const typePassenger = item
      if (typePassenger) {
        type = typePassenger.filter((typeItem: any) => typeItem.fareDetailsPerPassengerType.passengerType === "ADT")
      }
      //console.log(type)
      return type
    } else {
      return []

    }


  }
  passengerCTypeMapping(item: any) {

    let type: any = []

    if (item) {


      const typePassenger = item
      if (typePassenger) {
        type = typePassenger.filter((typeItem: any) => typeItem.fareDetailsPerPassengerType.passengerType === "CH" || typeItem.fareDetailsPerPassengerType.passengerType === "CHD" || typeItem.fareDetailsPerPassengerType.passengerType === "CNN")
      }
      //console.log(type)
      return type
    } else {
      return []

    }


  }
  passengerITypeMapping(item: any) {

    let type: any = []

    if (item) {


      const typePassenger = item
      if (typePassenger) {
        type = typePassenger.filter((typeItem: any) => typeItem.fareDetailsPerPassengerType.passengerType === "INF" || typeItem.fareDetailsPerPassengerType.passengerType === "IN")
      }
      //console.log(type)
      return type
    } else {
      return []

    }


  }
  fareMapping(fare: any, item: any, fareiItem: any) {
    if (fare?.fareTypeDisplay == item.fare[1]?.fareTypeDisplay) {
      let type: any[] = [];

      if (item?.flightDetailsList) {
        // for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[0]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareTypeDisplay === fare?.fareTypeDisplay && bookingItem?.corporateFare === fare.corporateFare);

        }
        // }
      }
      return type
      // You might want to return something here based on your requirements
      // return type?.fareDetailsPerPassengerType?.taxes;
    } else {
      return []
      // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
      // return '';
    }
  }
  fareOMapping(fare: any, item: any, fareiItem: any) {
    if (fare?.fareTypeDisplay == fare?.fareTypeDisplay) {
      let type: any[] = [];

      if (item?.flightDetailsList) {
        // for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[0]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareTypeDisplay === fare?.fareTypeDisplay && bookingItem?.corporateFare === fare.corporateFare);
        }
        // }
      }
      return type
      // You might want to return something here based on your requirements
      // return type?.fareDetailsPerPassengerType?.taxes;
    } else {
      return []
      // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
      // return '';
    }
  }

  fareTypeMapping(item: any) {
    if (item?.fare && item.fare[0]?.fareTypeDisplay) {
      // console.log(item)
      let type: any[] = [];

      if (item?.flightDetailsList) {
        // for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[0]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareTypeDisplay === item.fare[0]?.fareTypeDisplay && bookingItem?.corporateFare === item.fare[0]?.corporateFare);
        }
        // }
      }
      return type
      // You might want to return something here based on your requirements
      // return type?.fareDetailsPerPassengerType?.taxes;
    } else {
      return []
      // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
      // return '';
    }
  }

  getObjectKeysAndValues(obj: any): { key: string, value: any }[] {
    // console.log(this.departureFlight)
    // let flight:any=this.departureFlight


    if (obj) {

      let object: any = []
      object = Object.entries(obj).map(([key, value]) => ({ key, value }));
      for (let i = 0; i < object.length; i++) {
        //console.log(object[i].value)

        object[i].value = (object[i]?.value?.join(','))


      }
      return object;
    } else {
      return obj
    }
  }
  areDatesEqual(date1: Date, date2: Date): boolean {
    // Compare year, month, and day to check if the dates are equal
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }





  getObjectKeysAndValue(obj: any): { key: string, value: any }[] {
    // console.log(this.departureFlight)
    // let flight:any=this.departureFlight

    if (obj) {


      let object: any = []
      object = Object.entries(obj).map(([key, value]) => ({ key, value }));
      //    let hiddenKeys: any="bookingAmount,currency"
      // object=object.filter((item:any)=>!hiddenKeys.includes(item.key))


      return object;
    } else {
      return obj
    }
  }

  showDialog: boolean = false
  showAirDialog: boolean = false
  showTimeDialog: boolean = false
  OpenDialog() {
    this.showDialog = true
  }

  closeDialog() {
    this.showDialog = false
    this.showAirDialog = false
    this.showTimeDialog = false
  }
  OpenAirDialog() {
    this.showAirDialog = true
  }
  OpenTimeDialog() {
    this.showTimeDialog = true


  }
  sortByAsc: boolean = true
  sortByPrice(): void {
    if (this.sortByAsc) {
      this.flightDetail.sort((a: any, b: any) => {
        const priceA = a.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
        return priceA - priceB;
      });
    } else {
      this.flightDetail.sort((a: any, b: any) => {
        const priceA = a.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
        return priceB - priceA;
      });
    }
    if (this.returnFlightDetail) {
      if (this.sortByAsc) {
        this.returnFlightDetail.sort((a: any, b: any) => {
          const priceA = a.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          const priceB = b.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          return priceA - priceB;
        });
      } else {
        this.returnFlightDetail.sort((a: any, b: any) => {
          const priceA = a.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          const priceB = b.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          return priceB - priceA;
        });
      }
    }
    this.sortByAsc = !this.sortByAsc; // Toggle sorting order
  }
  
  minBaseFare: any
  

  minPrice: any
  maxPrice: any
  value: any
  calculateMinMaxPrices(): void {
    // const prices = this.flightDetail.map((flight:any) =>
    //   flight.fare.reduce((acc:any, curr:any) =>curr.baseFare+curr.finelTax, 0)
    // );
    let prices: any = []
    this.flightDetail.forEach((flight: any) =>
      flight.fare.forEach((curr: any) => {
        prices.push(curr?.baseFare + curr?.finalTax + (curr?.commercialData?.finalAmount||0))
      })
    );
   
    //console.log(prices)
    this.minPrice = Math.min(...prices);
    this.maxPrice = Math.max(...prices);

    // console.log(this.minPrice)
    // console.log(this.maxPrice)

  }
  fareTypeMenu: any
  fareTypeFilter() {
    const uniqueFareType = new Set<any>();
    const commonFareType: any[] = [];
    let fareTypes: any = []
    this.flightDetail.forEach((flight: any) =>
      flight.fare.forEach((curr: any) => {
        fareTypes.push(curr.fareTypeDisplay)
      })
    );
    for (let i = 0; i < fareTypes.length; i++) {

      if (uniqueFareType.has(fareTypes[i])) {
        // If the number is already in the set, it's a common number
        commonFareType.push(fareTypes[i]);
      } else {
        // Otherwise, add it to the set
        uniqueFareType.add(fareTypes[i]);
      }
    }

    this.fareTypeMenu = new Set([...uniqueFareType]);

  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }

  onMenuClick(event: any) {
    event.preventDefault();
    event.stopPropagation();


  }
  fareRuleMapping(item: any) {
    if (item?.fare && item.fare[0]?.fareTypeDisplay) {
      let type: any[] = [];

      if (item?.flightDetailsList) {
        for (let i = 0; i < item.flightDetailsList.length; i++) {
          const bookingClasses = item.flightDetailsList[i]?.bookingClasses;

          if (bookingClasses) {
            type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareTypeDisplay === item.fare[0]?.fareTypeDisplay && bookingItem?.corporateFare === item.fare[0]?.corporateFare);
          }
        }
      }
      return type
     
    } else {
      return []
     
    }
  }
  getFareRules() {
    for(let item of this.popupData){
    let rule = { "fareRules": 'pending' }
    item.farejson = rule
    var selectedFlight = JSON.parse(JSON.stringify(item));

    for (let i = 0; i < selectedFlight.flightDetailsList.length; i++) {
      selectedFlight.flightDetailsList[i].bookingClasses = this.fareRuleMapping(selectedFlight)
    }
    let request: any = {
      "paxCount": this.messageData?.paxCount,
      "adultCount": this.messageData?.adultCount,
      "childCount": this.messageData?.childCount,
      "infantCount": this.messageData?.infantCount,
      "selectedFlight": [
        {
          "fromAirport": this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport,
          "toAirport": this.messageData?.airSearchRequestBaseDetails[0]?.toAirport,
          "source": selectedFlight?.source,
          "flightDetailsList": selectedFlight?.flightDetailsList,
          "routeRequest": selectedFlight?.routeRequest
        }
      ]
    }

    this.FlightService
      .getFareRules(request)
      .subscribe({
        next: (res: any) => {
          if (res) {
            let data: any
            data = res
            //  console.log(data)
            let rule = data
            item.farejson = rule
            
            this.convertJson(item.farejson,item)

            //  this.json=this.convertJson()
          } else {
            let rule = { "fareRules": null }
            item.farejson = rule
            this.convertJson(item.farejson,item)

          }

        }, error: (err) => {
          let rule = { "fareRules": null }
          item.farejson = rule
          this.convertJson(item.farejson,item)


        }
      }
      )
    }
  }

  json: any = []
  rJson: any = []
 

farejson: any = {}
fareRjson: any = {}
  


  convertJson(item: any,json:any) {
    let data: any = []
    // console.log(item?.fareRules)
    data = this.getObjectKeysAndValue(item?.fareRules)
    // console.log(data)
    json.json = data
    // console.log(json.json)

  }

  getRFareRules() {
    let rule = { "fareRules": 'pending' }
    this.fareRjson = rule
    var selectedFlight = JSON.parse(JSON.stringify(this.returnFlight));

    for (let i = 0; i < selectedFlight.flightDetailsList.length; i++) {
      selectedFlight.flightDetailsList[i].bookingClasses = this.fareRuleMapping(selectedFlight)
    }
    let request: any = {
      "paxCount": this.messageData?.paxCount,
      "adultCount": this.messageData?.adultCount,
      "childCount": this.messageData?.childCount,
      "infantCount": this.messageData?.infantCount,
      "selectedFlight": [
        {
          "fromAirport": this.messageData?.airSearchRequestBaseDetails[0]?.toAirport,
          "toAirport": this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport,
          "source": selectedFlight?.source,
          "flightDetailsList": selectedFlight.flightDetailsList,
          "routeRequest": selectedFlight?.routeRequest
        }
      ]
    }

    this.FlightService
      .getFareRules(request)
      .subscribe({
        next: (res: any) => {
          if (res) {
            let data: any
            data = res
            //  console.log(data)
            let rule = data
            this.fareRjson = rule
            this.convertRJson(this.fareRjson)

            //  this.json=this.convertJson()
          } else {
            let rule = { "fareRules": null }
            this.fareRjson = rule
            this.convertRJson(this.fareRjson)

          }

        }, error: (err) => {
          let rule = { "fareRules": null }
          this.fareRjson = rule
          this.convertRJson(this.fareRjson)


        }
      }
      )

  }



  convertRJson(item: any) {
    let data: any = []
    data = this.getObjectKeysAndValue(item?.fareRules)
    this.rJson = data

  }


  
  enableCheck: boolean = false
  enableCheckBox() {
    if (this.enableCheck === true) {
      for (let i = 0; i < this.returnflight.length; i++) {
        this.returnflight[i].dropDown = true
        this.returnflight[i].selected = true

      }
      //   if(this.returnflight[1].flights){
      //   for(let i=0;i<this.returnflight[1].flights.length;i++){
      //     this.returnflight[1].flights[i].dropDown=true

      //  }}
    } else {
      this.SelectedEmailData = []
      this.allEmailData = []
      this.allInboundEmailData = []
      for (let i = 0; i < this.returnflight.length; i++) {
        this.returnflight[i].dropDown = false
        this.returnflight[i].selected = false
      }
      // if(this.returnflight[1].flights){
      //   for(let i=0;i<this.returnflight[1].flights.length;i++){
      //     this.returnflight[1].flights[i].dropDown=false
      //   }
      // }

    }
  }
  shareEmailPopup() {
    this.closeviewData()

    this.sharePopup = true
  }
  @ViewChild('travellerInput') travellerInput!: ElementRef<HTMLInputElement>;
  traveller = new FormControl('');
  filteredTo!: Observable<any[]>;
  travellerTo: any = []
  travellerName: any
  usersList: any;
  employeeData: any



  getCorporateUsers() {

    this.UserprofileService
      .getUserList()
      .subscribe({
        next: (res: any) => {
          if (res) {

            let data: any
            data = res
            this.usersList = data
            // console.log(this.usersList)
            this.usersList = this.usersList.filter((item: any) => item.firstName && item.firstName.trim() !== '');
            this.travellerTo = this.usersList
            this.filteredTo = this.traveller.valueChanges.pipe(
              // debounceTime(300), // Adjust the debounce time as needed
              //distinctUntilChanged(),
              startWith(null),
              map((item: any | null) => (item ? this._filter(item) : this.travellerTo.slice())),
            );
            // console.log(this.usersList)

          } else {
          }
        }, error: (err) => {


        }
      }
      )
  }
  private _filter(value: any): any[] {
    // console.log(value)
    const filterValue = value.toLowerCase();

    return this.travellerTo.filter((item: any) => item.username.toLowerCase().includes(filterValue));
  }
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.travellerName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.traveller.setValue(null);
  }


  onfilterChange(passengerDetails: any) {

    for (let i = 0; i < passengerDetails?.length; i++) {

      // console.log(passengerDetails[i]?.username)
      let data: any
      data = this.travellerTo.filter((item: any) => item.username === passengerDetails[i]?.username)
      // console.log(data)


    }
  }
  onfilterClick(value: any) {

    // this.travellerInput.nativeElement.value=''
    this.travellerEmail = value
    this.travellerCCEmail = value

    for (let i = 0; i < 3; i++) {


      let data: any
      data = this.travellerTo.filter((item: any) => item.username === value)


      

    }
  }

  selectedTo(event: MatAutocompleteSelectedEvent): void {

    this.travellerName = event.option.viewValue;

    this.travellerInput.nativeElement.value = event.option.viewValue;



    this.traveller.setValue(null);

  }
  getEmployeeData() {

    this.UserprofileService
      .getEmployeeUser()
      .subscribe({
        next: (res: any) => {
          if (res) {

            let data: any
            data = res
            this.employeeData = data




          } else {

          }
        }, error: (err) => {


        }
      }

      )

  }
  travellerCCEmail: any
  travellerEmail: any
  addCC: any = []
  addTO: any = []
  addT: any = []
  addC: any = []

  onClickTo() {
    if (this.travellerEmail === '') {
    } else {
      if (!this.addT.includes(this.travellerEmail)) {
        this.addT.push(this.travellerEmail);
      } else {
        // console.log('Duplicate value found:', this.travellerEmail);
      }

      if (this.addT.length === 0) {
      } else {
        this.addTO = this.addT.join(',')
      }
      // this.travellerInput.nativeElement.value=''
      this.travellerEmail = ''
    }
  }
  onClickCC() {
    if (this.travellerCCEmail === '') {
    } else {
      if (!this.addC.includes(this.travellerCCEmail)) {
        this.addC.push(this.travellerCCEmail);
      } else {
        //  console.log('Duplicate value found:', this.travellerCCEmail);
      }

      if (this.addC.length === 0) {
      } else {
        this.addCC = this.addC.join(',')

      }
      // this.travellerInput.nativeElement.value=''
      this.travellerCCEmail = ''
    }
  }
  fetchAllData: boolean = false
  sendAllData() {
    this.closeviewData()
    this.SelectedView = false

    this.sharePopup = true
    this.fetchAllData = true
    this.allEmailData = []
    this.allInboundEmailData = []



  }

  sendSelectedData() {
    this.closeviewData()
    this.SelectedView = true
    // this.viewData=true
    this.sharePopup = true
    // this.fetchAllData=true
    this.fetchAllData = true
    this.allEmailData = []
    this.allInboundEmailData = []

    this.allEmailData = JSON.parse(JSON.stringify(this.SelectedEmailData))
    
    for (let i = 0; i < this.allEmailData.length; i++) {
      this.allEmailData[i] = `\nOption ${1 + i} \n` + this.allEmailData[i]+'\n'
    }

    this.allEmailData = this.allEmailData.join('')
    this.allEmailData = `Outbound \n` + this.allEmailData

    // this.allInboundEmailData=this.allInboundEmailData.join('')

    if (this.returnflight[1]?.flights) {
      this.allInboundEmailData = JSON.parse(JSON.stringify(this.SelectedInboundEmailData))

      for (let i = 0; i < this.allInboundEmailData.length; i++) {
        this.allInboundEmailData[i] = `Option ${1 + i} \n` + this.allInboundEmailData[i]

      }

      this.allInboundEmailData = this.allInboundEmailData.join('')

      this.allInboundEmailData = `Inbound \n` + this.allInboundEmailData

    }


  }


  subjectEmail: any

  allRequest() {
    if (this.addCC) {
      if (this.addCC.length === 0) {
        this.addCC = ""
      }
    }
    let request: any = {

      sendBy: this.username,
      toEmail: this.addTO,
      ccEmail: this.addCC || "",
      bccEmail: '',
      body: this.returnflight,
      subject: this.subjectEmail,
      allOptions: this.returnflight,
      requestId: this.messageData.uuid,
      searchRequest: this.messageData
    }
    this.optionEmailSend(request)
  }
  formatDates(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MMM-yyyy HH:mm:ss");
    }
    return convertedValue;
  }
  allRequestDownload() {
    const mappedData: any[] = [];

    for (let flight of this.returnflight) {
      for (let fare of flight.fare) {
        // Make a fresh deep copy for each fare
        let emaiapi: any = { ...flight, fare: [fare] };
        mappedData.push(emaiapi);
      }
    }
    
    const mappedItemData = this.mapDataALLForExcel(mappedData);
    
    

    
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Flight Data');

    // Apply header styles
    this.applyHeaderStyles(worksheet);

    // Add the mapped data to the worksheet
    mappedItemData.forEach((item: any) => {
      worksheet.addRow(item);
    });

    // Save workbook to a file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'styled-flight-data.xlsx';
      link.click();
    });
  }


  mapDataForExcel(data: any[]): any[] {
    // console.log(data)
    return data.map((item: any, index: number) => {
    return item.itineraries.map((flight: any) => {
      return flight.flight.flightDetailsList.map((detail: any) => {
        return {
          'Bid#': index + 1,
          'Carrier Name': detail.carrierName,
          'Flight Number': detail.flightNumber,
          'From Airport': detail.fromAirport,
          'To Airport': detail.toAirport,
          'Scheduled Departure': this.formatDates(detail.schDepartureTime),
          'Scheduled Arrival': this.formatDates(detail.schArrivalTime),
          'Travel Duration': detail.travelDuration + ' mins',
          // 'Base Fare': flight.fare[0].baseFare,
          'Ticket Cost': item.fare[0].baseFare + item.fare[0].finalTax+item?.fare[0]?.commercialData?.finalAmount,
          'Fare Type': item.fare[0].fareTypeDisplay,
          'Refundable': item.fare[0].refundable ? 'Yes' : 'No',
          'Meal Included': item.fare[0].hasFreeMeal ? 'Yes' : 'No',
        };
      });}).flat();
    }).flat(); // Flatten the array as we have multiple flightDetails
  }
  mapDataALLForExcel(data: any[]): any[] {
    return data.map((item: any, index: number) => {
    return item.itineraries.map((flight: any) => {
      return flight.flight.flightDetailsList.map((detail: any) => {
        return {
          'Bid#': index + 1,
          'Carrier Name': detail.carrierName,
          'Flight Number': detail.flightNumber,
          'From Airport': detail.fromAirport,
          'To Airport': detail.toAirport,
          'Scheduled Departure': this.formatDates(detail.schDepartureTime),
          'Scheduled Arrival': this.formatDates(detail.schArrivalTime),
          'Travel Duration': detail.travelDuration + ' mins',
          // 'Base Fare': flight.fare[0].baseFare,
          'Ticket Cost': item.fare[0].baseFare + item.fare[0].finalTax+item?.fare[0]?.commercialData?.finalAmount,
          'Fare Type': item.fare[0].fareTypeDisplay,
          'Refundable': item.fare[0].refundable ? 'Yes' : 'No',
          'Meal Included': item.fare[0].hasFreeMeal ? 'Yes' : 'No',
        };
      });}).flat();
    }).flat(); // Flatten the array as we have multiple flightDetails
  }

  applyHeaderStyles(worksheet: ExcelJS.Worksheet): void {
    // Define the headers
    worksheet.columns = [
      { header: 'Bid#', key: 'Bid#', width: 15 },
      { header: 'Carrier Name', key: 'Carrier Name', width: 20 },
      { header: 'Flight Number', key: 'Flight Number', width: 20 },
      { header: 'From Airport', key: 'From Airport', width: 20 },
      { header: 'To Airport', key: 'To Airport', width: 20 },
      { header: 'Scheduled Departure', key: 'Scheduled Departure', width: 25 },
      { header: 'Scheduled Arrival', key: 'Scheduled Arrival', width: 25 },
      { header: 'Travel Duration', key: 'Travel Duration', width: 20 },
      // { header: 'Base Fare', key: 'Base Fare', width: 15 },
      { header: 'Ticket Cost', key: 'Ticket Cost', width: 15 },
      { header: 'Fare Type', key: 'Fare Type', width: 20 },
      { header: 'Refundable', key: 'Refundable', width: 15 },
      { header: 'Meal Included', key: 'Meal Included', width: 15 }
    ];

    // Apply styles to the first row (headers)
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0000FF' } // blue background
      };
    });
  }

  selectedRequestDownload(): void {
    // Map the data to the format of the Excel

   
    const mappedData = this.mapDataForExcel(this.sendEmailApiData);

    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Flight Data');

    // Apply header styles
    this.applyHeaderStyles(worksheet);

    // Add the mapped data to the worksheet
    // const mappedflattenData = this.flattenFlightArray(mappedData);

    mappedData.forEach((item) => {
      worksheet.addRow(item);
    });

    // Save workbook to a file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'styled-flight-data.xlsx';
      link.click();
    });
  }
  // Method to export the mapped data to Excel with colored headers


  flattenFlightArray(data: any[][]): any[] {
    return data.flat(); // modern, clean method
  }


  
  selectedRequestDownloada(): void {
    // Map the data to the format of the Excel
    const mappedData = this.mapDataForExcel(this.sendEmailApiData);

    // Prepare the worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mappedData);

    // Apply header styles
    // this.applyHeaderStyles(ws);

    // Prepare the workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Flight Data');

    // Export the file
    const fileName = 'aligned_flight_data_with_styled_headers.xlsx';
    XLSX.writeFile(wb, fileName);
  }
  selectedRequestDownloads() {

    let curdatestring: Date = new Date()
    // let  exportData:any=JSON.parse(this.userExcel)
    // console.log(this.sendEmailApiData)
    const dataWithUppercaseHeaders = this.sendEmailApiData.map((item: any) => {
      const transformedItem: any = {};
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          transformedItem[key.toUpperCase()] = item[key];
        }
      }
      return transformedItem;
    });

    // Convert the modified data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(dataWithUppercaseHeaders);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write the workbook to a file
    XLSX.writeFile(workbook, "FLIGHT" + curdatestring + ".xlsx");


  }




  selectedRequest() {
    if (this.addCC) {
      if (this.addCC.length === 0) {
        this.addCC = ""
      }
    }
    let request: any = {

      sendBy: this.username,
      toEmail: this.addTO,
      ccEmail: this.addCC || "",
      bccEmail: '',
      body: this.sendEmailApiData,
      subject: this.subjectEmail,
      allOptions: this.returnflight,
      requestId: this.messageData.uuid,
      searchRequest: this.messageData

    }
    this.optionEmailSend(request)
  }
  optionEmailSend(request: any) {

    this.FlightService.optionEmailSend(request)
      .subscribe({
        next: (res: any) => {
          if (res) {

            let data: any
            data = res
            this.toastMsgService.setMsg({ msg: "Email Sent Successfully ", msgTitle: "Success", msgType: "I" });





          } else {
            this.toastMsgService.setMsg({ msg: "Email Sent Successfully ", msgTitle: "Success", msgType: "I" });

          }
        }, error: (err) => {
          this.toastMsgService.setMsg({ msg: "Failed To Send Email ", msgTitle: "Warning", msgType: "W" });


        }
      }

      )

  }


  onClickView() {
    this.viewData = true
    this.allEmailData = []
    this.allInboundEmailData = []
    // console.log(this.returnflight[0].flights)
    // let data: any = []






    for (let flight of this.returnflight) {


      let flightList:any=''
      for(let i=0 ;i<flight.itineraries.length;i++){
        // let fares:any=flight.itineraries[i].flight.fare.filter((fareItem:any)=>fareItem.fareTypeDisplay===fare.fareTypeDisplay)
      flightList+= this.shareFilter(flight.itineraries[i].flight.flightDetailsList)
    
  }
  

      // data.push(flight)


      for (let fare of flight?.fare) {
        // `${flight?.flightDetailsList[0]?.carrierName}${ flight?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[0]?.fromAirport }${ this.returnflight[0]?.toAirport } ${ this.dateFormatMMM(flight?.schDepartureTime)} ${ this.dateFormatHH(flight?.schDepartureTime) } ${this.dateFormatHH( flight?.schArrivalTime) }`+'\n'
        this.allEmailData.push(flightList +
          `Ticket Cost: INR ${fare?.baseFare + fare?.finalTax + fare?.commercialData?.finalAmount}` + '\n' +
          `Fare Type: ${fare?.fareTypeDisplay}` + '\n')
      }
    }
    // console.log(data)

    for (let i = 0; i < this.allEmailData.length; i++) {
      this.allEmailData[i] = `Option ${1 + i} \n` + this.allEmailData[i]+'\n'

    }
    // console.log(this.allEmailData)

    this.allEmailData = this.allEmailData.join('')

    this.allEmailData = `Outbound \n` + this.allEmailData

  

  }
  onSelectedkView() {
    this.SelectedView = true
    this.viewData = true


  }
  dateFormatMMM(date: any) {
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-US');
    date = datePipe.transform(parsedDate, 'dd MMM');
    return date

  }
  dateFormatHH(date: any) {
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-US');
    date = datePipe.transform(parsedDate, 'HHmm');
    return date

  }
  closeviewData() {
    this.viewData = false
  }
  sendEmailApiData: any = []
  shareFilter(item: any) {

    let data: any = ''
    item.forEach((flightDetailsList: any) => {
      data += `${flightDetailsList?.carrierName}${flightDetailsList?.flightNumber} ${flightDetailsList?.fromAirport}${flightDetailsList?.fromTerminal?('_T-'+flightDetailsList?.fromTerminal):''} ${flightDetailsList?.toAirport}${flightDetailsList?.toTerminal?('_T-'+flightDetailsList?.toTerminal):''} ${this.dateFormatMMM(flightDetailsList?.schDepartureTime)} ${this.dateFormatHH(flightDetailsList?.schDepartureTime)} ${this.dateFormatHH(flightDetailsList?.schArrivalTime)}` + '\n'
    })
    return data
  }
  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  selectShareData(event: any, item: any, fare: any) {

    if (event.target.checked) {
let flightList:any=''
      for(let i=0 ;i<item.itineraries.length;i++){
        // let fares:any=item.itineraries[i].flight.fare.filter((fareItem:any)=>fareItem.fareTypeDisplay===fare.fareTypeDisplay)
// console.log(fares)
// if(fares.length!=0){
      flightList+= this.shareFilter(item.itineraries[i].flight.flightDetailsList)
    // }
  }
  let emaiapi: any = { ...item }
  emaiapi.fare = [fare]
  const uuid = this.generateUUID();

    // Attach uuid to fare and item
  this.SelectedEmailData.push( flightList+
    `Ticket Cost: INR ${fare?.baseFare + fare?.finalTax + fare?.commercialData?.finalAmount}` + '\n' +
    `Fare Type: ${fare.fareTypeDisplay}` + '\n')
    emaiapi.uuid=uuid
    emaiapi.text=flightList+
    `Ticket Cost: INR ${fare?.baseFare + fare?.finalTax + fare?.commercialData?.finalAmount}` + '\n' +
    `Fare Type: ${fare.fareTypeDisplay}` + '\n'
      this.sendEmailApiData.push(emaiapi)

    } else {
      let flightList:any=''

      for(let i=0 ;i<item.itineraries.length;i++){
        // let fares:any=item.itineraries[i].flight.fare.filter((fareItem:any)=>fareItem.fareTypeDisplay===fare.fareTypeDisplay)
        flightList+=this.shareFilter(item.itineraries[i].flight.flightDetailsList)
       }
       let detail =  flightList+
        `Ticket Cost: INR ${fare?.baseFare + fare?.finalTax + fare?.commercialData?.finalAmount}` + '\n' +
        `Fare Type: ${fare?.fareTypeDisplay}` + '\n'
      let emaiapi: any = { ...item }
      emaiapi.fare = [fare]
      this.SelectedEmailData = this.SelectedEmailData.filter((items: any) => items !== detail)

const matchingSelected = this.sendEmailApiData.find((data:any) => data.text === detail);
const uuidToRemove = matchingSelected?.uuid;
this.sendEmailApiData = this.sendEmailApiData.filter((data:any) => data.uuid !== uuidToRemove);

      // this.sendEmailApiData = this.sendEmailApiData.filter((items: any) =>   items.fare[0].fareTypeDisplay !== emaiapi.fare[0].fareTypeDisplay || items.fare[0].baseFare !== emaiapi.fare[0].baseFare || items.fare[0].finalTax !== emaiapi.fare[0].finalTax || items.flightDetailsList[0].fromAirport !== emaiapi.flightDetailsList[0].fromAirport || items.flightDetailsList[0].toAirport !== emaiapi.flightDetailsList[0].toAirport || items.flightDetailsList[0].schArrivalTime !== emaiapi.flightDetailsList[0].schArrivalTime || items.flightDetailsList[0].schDepartureTime !== emaiapi.flightDetailsList[0].schDepartureTime)
  
      
      
      }

  }




  
  selectRShareData(event: any, item: any, fare: any) {
    if (event.target.checked) {
      // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
      this.SelectedInboundEmailData.push(this.shareFilter(item?.flightDetailsList) +
        `Ticket Cost: INR ${fare?.baseFare + fare?.finalTax + fare?.commercialData?.finalAmount}` + '\n' +
        `Fare Type: ${fare?.fareTypeDisplay}` + '\n')

    } else {
      // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
      let detail = this.shareFilter(item?.flightDetailsList) +
        `Ticket Cost: INR ${fare?.baseFare + fare?.finalTax + fare?.commercialData?.finalAmount}` + '\n' +
        `Fare Type: ${fare?.fareTypeDisplay}` + '\n'
      this.SelectedInboundEmailData = this.SelectedInboundEmailData.filter((item: any) => item !== detail)
    }
  }

  distancePlus(distance: any) {

    let item = 0
    for (let items of distance) {

      item += Number(items?.distance) || 0

    }
    if (item === 0) {
      return ''

    } else {
      return item + (distance[0].unit ? (distance[0].unit) : ' Miles')

    }
  }

  carbonPlus(item: any) {
    let itms = 0
    for (let items of item) {

      itms += items?.carbonEmission?.emission?.economy || 0

    }
    return itms / 1000
  }
  carbonfirstPlus(item: any) {
    let itms = 0
    for (let items of item) {

      itms += items?.carbonEmission?.emission?.first || 0

    }
    return itms / 1000
  }
  carbonpremiumEconomyPlus(item: any) {
    let itms = 0
    for (let items of item) {

      itms += items?.carbonEmission?.emission?.premiumEconomy || 0

    }
    return itms / 1000
  }
  carbonbusinessPlus(item: any) {
    let itms = 0
    for (let items of item) {

      itms += items?.carbonEmission?.emission?.business || 0

    }
    return itms / 1000
  }

 
  convertjson(item: any) {
    if (item) {
      return JSON.parse(item)

    } else {
      return item
    }
  }
  filterCharges(item: any) {
    let airlineAmount: any
    let platform: any

    airlineAmount = item.filter((item: any) => item.type === 'airline')
    platform = item.filter((item: any) => item.type === 'platform')

    if (airlineAmount[0]?.amount === 0) {
      return 'Non Refundable'

    } else {
      return airlineAmount[0]?.amount + ' ' + airlineAmount[0]?.currency
      // +platform[0]?.amount?('+'):''+platform[0]?.amount +' '+ platform[0]?.currency
    }
  }

  scheduleFilter(item: any) {
    item = item.split(':')
    if (item[1] === 'h' || item[1] === 'H') {
      let hours = "hours"
      return item[0] + ' hours'
    } else if (item[1] === 'd' || item[1] === 'D') {
      return item[0] + ' days'

    } else {
      return ''
    }
  }


  transform(htmlData: string, category: string): string {
    // Use regular expressions or string manipulation to filter data by category
    const startTag = `${category}`;
    const startIndex = htmlData.indexOf(startTag);
    if (startIndex === -1) {
      return ''; // Category not found
    }
    const endIndex = htmlData.indexOf('<p style=\"font-size:8.5pt;margin:0;\"><br></p>', startIndex);
    if (endIndex === -1) {
      return ''; // End tag not found
    }
    return htmlData.substring(startIndex, endIndex);
  }
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  onClickCancellationTab() {
    this.tabGroup.selectedIndex = 2;
  }
  onClickITINERARYTab() {
    this.tabGroup.selectedIndex = 0;

  }





  calculateDateDifference(departureDate: any, arrivalDate: any) {
    // Parse the dates
    let departure: any = new Date(departureDate);
    let arrival: any = new Date(arrivalDate);

    // Calculate the difference in milliseconds
    const difference = arrival - departure;

    // Convert difference from milliseconds to days
    const days = difference / (1000 * 60 * 60 * 24);

    // Format the output
    if (days <= 0) {
      return "";
    } else {
      if (Math.round(days) != 0) {
        return `+${Math.round(days)} DAY`; // Rounds the days to the nearest whole number

      } else {
        return ''
      }
    }
  }


  getrepriceData(flights: any) {
// console.log(flights)
    let lastflight: any
    let returnLastFlight: any
    let data: any = []
    // if (returnFlights) {
    //   for (let i = 0; i < flights.flightDetailsList.length; i++) {
    //     lastflight = flights?.flightDetailsList[flights?.flightDetailsList.length - 1];

        

    //     flights.flightDetailsList[i].bookingClasses = flights.flightDetailsList[i].bookingClasses?.filter((item: any) => item.fareType === flights.fare[0].fareType && item?.corporateFare === flights.fare[0].corporateFare)
    //   }
    //   for (let i = 0; i < returnFlights.flightDetailsList.length; i++) {
    //     returnLastFlight = returnFlights?.flightDetailsList[returnFlights?.flightDetailsList.length - 1];

       

    //     returnFlights.flightDetailsList[i].bookingClasses = returnFlights.flightDetailsList[i].bookingClasses?.filter((item: any) => item.fareType === returnFlights.fare[0].fareType && item?.corporateFare === returnFlights.fare[0].corporateFare)
    //   }
    //   data = {

    //     "paxCount": this.messageData?.adultCount + this.messageData?.childCount + this.messageData?.infantCount,
    //     "adultCount": this.messageData?.adultCount,
    //     "childCount": this.messageData?.childCount,
    //     "infantCount": this.messageData?.infantCount,
    //     // "prefAirSource": this.flights?.source,
    //     "selectedFlight": [
    //       {
    //         "otherData": flights?.otherData,
    //         "routeRequest": flights?.routeRequest,
    //         "source": flights?.routeRequest?.source,
    //         "fromAirport": flights?.flightDetailsList[0].fromAirport,
    //         "toAirport": lastflight?.toAirport,
    //         "flightDetailsList": flights?.flightDetailsList

    //       },
    //       {
    //         "otherData": returnFlights?.otherData,
    //         "routeRequest": returnFlights?.routeRequest,
    //         "source": returnFlights?.routeRequest?.source,
    //         "fromAirport": returnFlights?.flightDetailsList[0].fromAirport,
    //         "toAirport": returnLastFlight?.toAirport,
    //         "flightDetailsList": returnFlights?.flightDetailsList

    //       }
    //     ],

    //   }
    //   //console.log(data)

    // } 
    
      for (let i = 0; i < flights.flightDetailsList.length; i++) {
        lastflight = flights?.flightDetailsList[flights?.flightDetailsList.length - 1];

       


        flights.flightDetailsList[i].bookingClasses = flights.flightDetailsList[i].bookingClasses?.filter((item: any) => item.fareTypeDisplay === flights.fare[0].fareTypeDisplay && item?.corporateFare === flights.fare[0].corporateFare)
      }
      data = {

        "paxCount": this.messageData?.adultCount + this.messageData?.childCount + this.messageData?.infantCount,
        "adultCount": this.messageData?.adultCount,
        "childCount": this.messageData?.childCount,
        "infantCount": this.messageData?.infantCount,
        //"prefAirSource": this.flights?.source,
        "selectedFlight": [
          {
            "otherData": flights?.otherData,
            "routeRequest": flights?.routeRequest,
            "source": flights?.routeRequest?.source,
            "fromAirport": flights?.flightDetailsList[0].fromAirport,
            "toAirport": lastflight?.toAirport,
            "flightDetailsList": flights?.flightDetailsList

          }
        ],

      }

    


    this.FlightService
      .getReprice(data)
      .subscribe({
        next: (res: any) => {
          if (res.length > 0) {
            let item: any
            item = res
            item[0].forEach((flight: any) => {
              if (flight.flightDetailsList) {
                flight.flightDetailsList[0].bookingClasses.forEach((bookingClass: any) => {
                 

                  flights.flightDetailsList[0].bookingClasses.forEach((dataBookingClass: any) => {
                    if (dataBookingClass.fareDetailsPerPassengerType.passengerType === bookingClass.fareDetailsPerPassengerType.passengerType) {

                      if (dataBookingClass.fareTypeDisplay === bookingClass.fareTypeDisplay) {
                        if (dataBookingClass.corporateFare === bookingClass.corporateFare) {


                          dataBookingClass.fareDetailsPerPassengerType = bookingClass.fareDetailsPerPassengerType
                        }
                      }
                    }
                  });


                });
              }
            });

            this.loadMoreFlights()
            // if (returnFlights) {

            //   item[1].forEach((flight: any) => {
            //     if (flight.flightDetailsList) {

            //       flight.flightDetailsList[0].bookingClasses.forEach((bookingClass: any) => {
                   
            //         this.returnFlight.flightDetailsList[0].bookingClasses.forEach((dataBookingClass: any) => {
            //           if (dataBookingClass.fareDetailsPerPassengerType.passengerType === bookingClass.fareDetailsPerPassengerType.passengerType) {

            //             if (dataBookingClass.fareType === bookingClass.fareType) {
            //               if (dataBookingClass.corporateFare === bookingClass.corporateFare) {


            //                 dataBookingClass.fareDetailsPerPassengerType = bookingClass.fareDetailsPerPassengerType
            //               }
            //             }
            //           }

            //         });



            //       });
            //     }
            //   });



            // }



            let fare: any = 0



          } else {

          }

        }, error: (err) => {

        }
      }
      )

  }
  phoneNumber: any

  copyToClipboard() {
    // Copy the text to the clipboard
    // navigator.clipboard.writeText();

    navigator.clipboard.writeText(this.allEmailData + this.allInboundEmailData)
   
    this.toastMsgService.setMsg({ msg: "Text Copied !", msgTitle: "", msgType: "I" });
  }
  sendWhatsApp() {
    // const encodedMessage = encodeURIComponent(this.allEmailData+this.allInboundEmailData);
    // const encodedNumber = encodeURIComponent(this.phoneNumber);

    // // Create the WhatsApp Web link with the recipient's number and the message
    // const whatsAppWebLink = `https://web.whatsapp.com/send?phone=${encodedNumber}&text=${encodedMessage}`;

    // // Open the WhatsApp Web link in a new tab or window
    // window.open(whatsAppWebLink, '_blank');
  }
  resetFilter() {
    this.filterTime = null
    this.airlines = null
    this.stop = null
    this.flightDetail = this.returnflight[0].flights;
    if (this.returnFlightDetail.length > 0) {
      this.returnFlightDetail = this.returnflight[1].flights;
    }


  }
  private getTimeCategory(date: Date, time: any) {
    const uniqueDate = new Set<Date>();
    const commonNumbers: any[] = [];
    // for(let i=0;i< this.returnflight[0].flights.length;i++){

    if (uniqueDate.has(this.formatDate(time)
    )) {
      // If the number is already in the set, it's a common number
      commonNumbers.push(this.formatDate(time)
      );
    } else {
      // Otherwise, add it to the set
      uniqueDate.add(this.formatDate(time)
      );
    }


    // }
    let Ddata: any = []
    Ddata = Array.from(uniqueDate)


    if (date >= new Date(Ddata[0] + 'T00:00:00.000+05:30') && date <= new Date(Ddata[0] + 'T08:00:00.000+05:30')) {
      return 'earlyMorning';
    } else if (date >= new Date(Ddata[0] + 'T08:00:00.000+05:30') && date <= new Date(Ddata[0] + 'T14:00:00.000+05:30')) {
      return 'morning';
    } else if (date >= new Date(Ddata[0] + 'T14:00:00.000+05:30') && date <= new Date(Ddata[0] + 'T16:00:00.000+05:30')) {
      return 'afternoon';
    } else if (date >= new Date(Ddata[0] + 'T16:00:00.000+05:30') && date <= new Date(Ddata[0] + 'T20:00:00.000+05:30')) {
      return 'evening';
    } else {
      return 'night';
    }
  }

  fareType: any
  combineFilters() {
    // Filter data based on selected filters


    /*++++++++++++++++++++++++ oneWay+++++++++++++++++++++++*/
    let filteredData = this.returnflight.filter((flight: any) => {
      // Filter by time
      if (this.filterTime && this.filterTime.length > 0) {
        // const schDepartureTime = new Date(flight.schDepartureTime);
        // const hour = schDepartureTime.getHours();
        const schDepartureTime = new Date(flight.itineraries[0].flight.schDepartureTime);
        const category = this.getTimeCategory(schDepartureTime, flight.itineraries[0].flight.schDepartureTime);
        if (!this.filterTime.includes(category)) {
          return false;
        }
      }
      // Filter by stops
      if (this.stop && this.stop > 0) {
        if (flight.itineraries[0].flight.hopCount != this.stop) {
          return false;
        }
      }

      // Filter by airlines
      if (this.airlines && this.airlines.length > 0) {
        if (!this.airlines.includes(flight.itineraries[0].flight.flightDetailsList[0].carrierName)) {
          return false;
        }
      }
      if (this.value) {
        const hasValidFare = flight.fare.some((f: any) =>
          f.baseFare + f.finalTax + (f?.commercialData?.finalAmount || 0) >= this.value
        );

        if (!hasValidFare) {

          return false;
        }
      }


      if (this.fareType && this.fareType.length > 0) {
        var hasFareType = flight.fare.some((f: any) => this.fareType.includes(f.fareTypeDisplay));
        if (!hasFareType) {
          return false;
        }
      }
      return true;
    });


    this.flightDetail = filteredData

    this.loadMoreFlights()
    //   /*++++++++++++++++++++++++ Return +++++++++++++++++++++++*/
    //   if(this.returnFlightDetail.length>0){
    //   let filteredReturnData = this.returnflight[1].flights.filter((flight:any) => {
    //     // Filter by time
    //     if (this.filterTime&&this.filterTime.length > 0) {
    //       // const schDepartureTime = new Date(flight.schDepartureTime);
    //       // const hour = schDepartureTime.getHours();
    //       const schDepartureTime = new Date(flight.schDepartureTime);
    //       const category = this.getTimeCategory(schDepartureTime,flight.schDepartureTime);
    //       if (!this.filterTime.includes(category)) {
    //         return false;
    //       }
    //     }
    // // Filter by stops
    //     if (this.stop && this.stop > 0) {
    //       if (flight.hopCount != this.stop) {
    //         return false;
    //       }
    //     }

    //     // Filter by airlines
    //     if (this.airlines&&this.airlines.length > 0) {
    //       if (!this.airlines.includes(flight.flightDetailsList[0].carrierName)) {
    //         return false;
    //       }
    //     }
    //     if (this.value) {
    //       const hasValidFare = flight.fare.some((f: any) => 
    //         f.baseFare + f.finalTax + (f?.commercialData?.finalAmount || 0) >= this.value
    //       );
    //       if (!hasValidFare) {
    //         return false;
    //       }
    //     }
    //     return true;
    //   });


    //   this.returnFlightDetail=filteredReturnData}


  }


  // public lastScrolledHeight: number = 0;
  // public showAddButton: boolean = true;

  // @HostListener('window:scroll', []) onScroll(event:any) {
  //   // this.cdr.detectChanges(); 

  //    const currentScrollHeight = window.scrollY;
  //   console.log(currentScrollHeight);

  //   if (currentScrollHeight > this.lastScrolledHeight) {
  //     this.showAddButton = false;
  //     console.log('should NOT show button');
  //   } else {
  //     this.showAddButton = true;
  //     console.log('should show button');
  //   }
  //   this.lastScrolledHeight = currentScrollHeight;
  //     console.log(this.lastScrolledHeight)
  // }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  sortAirlineOrder: boolean = true
  sortDepartOrder: boolean = true
  sortArrivesOrder: boolean = true

  combineFlilter(item: any) {
    // for(let i=0;i<this.returnflight[0].flights.length;i++){
    //   this.returnflight[0].flights[i].dropDown=false


    // }
    if (item === 'airline') {



      // this.flightDetail.sort((sort:any)=>sort.flightDetailsList[0].carrierName)
      if (this.sortAirlineOrder) {
        this.flightDetail.sort((a: any, b: any) => a.itineraries[0].flight.flightDetailsList[0].carrierName.localeCompare(b.itineraries[0].flight.flightDetailsList[0]?.carrierName));
      } else {
        this.flightDetail.sort((a: any, b: any) => b.itineraries[0].flight.flightDetailsList[0].carrierName.localeCompare(a.itineraries[0].flight.flightDetailsList[0]?.carrierName));

      }

      this.sortAirlineOrder = !this.sortAirlineOrder;

    }
    if (item === 'departs') {

      if (this.sortDepartOrder) {
        this.flightDetail.sort((a: any, b: any) => a.itineraries[0].flight.schDepartureTime.localeCompare(b.itineraries[0].flight.schDepartureTime));

      } else {
        this.flightDetail.sort((a: any, b: any) => b.itineraries[0].flight.schDepartureTime.localeCompare(a.itineraries[0].flight.schDepartureTime));

      }

      this.sortDepartOrder = !this.sortDepartOrder;
    }
    if (item === 'arrives') {
      if (this.sortArrivesOrder) {
        this.flightDetail.sort((a: any, b: any) => a.itineraries[0].flight.schArrivalTime.localeCompare(b.itineraries[0].flight.schArrivalTime));

      } else {
        this.flightDetail.sort((a: any, b: any) => b.itineraries[0].flight.schArrivalTime.localeCompare(a.itineraries[0].flight.schArrivalTime));

      }
      this.sortArrivesOrder = !this.sortArrivesOrder;

    }
    if (item === 'price') {
      if (this.sortByAsc) {
        this.flightDetail.sort((a: any, b: any) => {
          const priceA = a.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          const priceB = b.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          return priceA - priceB;
        });
      } else {
        this.flightDetail.sort((a: any, b: any) => {
          const priceA = a.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          const priceB = b.fare.reduce((acc: any, curr: any) => acc + curr.baseFare, 0);
          return priceB - priceA;
        });
      }
    }
    this.sortByAsc = !this.sortByAsc


    this.loadMoreFlights()
  }
  viewText: any = 'view'

  onClickTitle(item: any) {
    this.viewText = item

  }
  sortInfo: any = ['Airlines', 'Departure']
  Incv: any
  net: any
  rules: boolean = false
  IncentiveBoolean() {
    this.FlightService.AIR_SHOW_INCENTIVE()
      .subscribe({
        next: (res: any) => {
          if (res) {
            let data = res
            // console.log(data[0])
            // console.log( this.domIn)
            if (data.rule === '0') {
              this.rules = false

            } else if (data.rule === '1') {
              this.rules = true

            }

          } else {

          }
        }, error: (err) => {

        }
      }
      )
  }


  endIndex = 20;  // Start by showing the first 20 items
  increments = 20;
  private debounceTimer: any; // For debouncing

onScroll(event: any) {
  // console.log('scroll event detected');

  const element = event.target;
  const scrollPosition = element.scrollTop + element.clientHeight;
    const scrollHeight = element.scrollHeight;
    const scrollPercentage = (scrollPosition / scrollHeight) * 100;
  // console.log(element.scrollHeight,element.scrollTop, element.clientHeight)
  if (scrollPercentage>=80) {
    // If scrolled to the bottom, load more hotels
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(() => {
      this.loadMoreFlights();
    }, 200); // Delay by 200ms
    // this.loadMoreFlights();
  }
}
loadMoreFlights() {

  const nextIndex = Math.min(this.endIndex + this.increments, this.flightDetail.length);
  this.visibleflights = this.flightDetail.slice(0, nextIndex);
  this.endIndex = nextIndex;
  // console.log(this.visibleflights)
}

countdown: number = 600;
interval: any;
startTimer(): void {
  this.interval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
    } else {
      // this.goBack()
     
      clearInterval(this.interval);
      // Timer has completed. You can add more logic here if needed.
    }
  }, 1000); // 1000 milliseconds = 1 second
}
convertSecondsToMinSec(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes} minutes ${remainingSeconds} seconds`;
}


test(){

}
}
